<template>
  <div class="col-sm-6" id="searchbox">
    <div class="row text-center" id="search-icons-large">

      <div class="col-sm-2">

      </div>
      <div class="col-sm-2">

      </div>
      <div class="col-sm-1">

      </div>

      <div class="col-sm-2">
        <img :src="'/assets/images/tour.png'">
        <a class="search-link active" href="#">Tourism</a>
      </div>

      <!--      <div class="col-sm-2">-->
      <!--        <img :src="'/assets/images/trade.png'">-->
      <!--        <a class="search-link" href="#">Trades</a>-->
      <!--      </div>-->
      <!--      <div class="col-sm-2">-->
      <!--        <img :src="'/assets/images/services.png'">-->
      <!--        <a class="search-link" href="#">Services</a>-->
      <!--      </div>-->
      <!--      <div class="col-sm-2">-->
      <!--        <img :src="'/assets/images/prof.png'">-->
      <!--        <a class="search-link" href="#">Professionals</a>-->
      <!--      </div>-->
      <div class="col-sm-2">

      </div>
    </div>

    <div class="row text-center" id="search-icons-small">

      <div class="col-sm-1">
      </div>
      <div class="col-sm-10">
        <br class="search-section-spacer">
        <img :src="'/assets/images/tour.png'">
        <!--        <img :src="'/assets/images/trade.png'">-->
        <!--        <img :src="'/assets/images/services.png'">-->
        <!--        <img :src="'/assets/images/prof.png'">-->
        <br class="search-section-spacer">
        <a class="search-link active" href="#">Tour</a>
        <!--        <a class="search-link" href="#">Trades</a>-->
        <!--        <a class="search-link" href="#">Services</a>-->
        <!--        <a class="search-link" href="#">Prof</a>-->
      </div>
      <div class="col-sm-1">
      </div>
    </div>


    <div class="row" id="search-large">
      <div class="col-sm-3">
      </div>
      <div class="col-sm-6">
        <div class="text-center" id="tagline">
          <p>Easy to find... Simple to use</p>
        </div>
      </div>
      <div class="col-sm-3">
      </div>

    </div>

    <div class="row text-center home-select" id="search-buttons">
      <div class="col-sm-12">
        <br class="search-section-spacer">
        <div class="row g-0 button-heading-padding">
          <label class="col-4 col-sm-4 button-heading">Pick</label>
          <label class="col-4 col-sm-4 button-heading">Choose</label>
          <label class="col-4 col-sm-4 button-heading">Match</label>
        </div>
        <br>
        <!--        <ul>-->
        <!--          <li v-for="country in countries" :key="country.id">-->
        <!--            {{country.name}}-->
        <!--          </li>-->
        <!--        </ul>-->
        <div class="row g-0 home-select-row">
          <div class="col-12 col-sm-4 mb-2 mb-sm-0">
            <select class="custom-select" v-model="countrySelect" @change="setCountry">
              <option value="" disabled>Select Country</option>
              <option v-for="country in selectableCountries" :key="country.id"
                      v-bind:value="{id: country.id, text: country.name}" >{{ country.name }}
              </option>
            </select>
          </div>
          <div class="col-12 col-sm-4 mb-2 mb-sm-0">
            <select class="custom-select" @change="setState" v-model="state" :disabled="!countrySelect">
              <option value="" disabled>Select State</option>
              <option v-for="state in getStates" :key="state.id" v-bind:value="{id: state.id, text: state.name}">
                {{ displayStateName(state.name) }}
              </option>
            </select>
          </div>
          <div class="col-12 col-sm-4">
            <select class="custom-select" @change="setRegion" :disabled="!state" v-model="region">
              <option value="" disabled>Select Region</option>
              <option v-for="region in getRegions" :key="region.id" v-bind:value="{id: region.id, text: region.name}">
                {{ region.name }}
              </option>
            </select>
          </div>
        </div>

      </div>
    </div>

    <div class="row text-center home-select" id="search-buttons-small">
      <div class="col-12">
        <br class="search-section-spacer">
        <div class="row g-0 home-select-row mobile-select-stack">
          <div class="col-12 mb-2">
            <label class="button-heading d-block text-left mb-1">Pick</label>
            <select class="custom-select" v-model="countrySelect" @change="setCountry">
              <option value="" disabled>Select Country</option>
              <option v-for="country in selectableCountries" :key="country.id"
                      v-bind:value="{id: country.id, text: country.name}" >{{ country.name }}
              </option>
            </select>
          </div>
          <div class="col-12 mb-2">
            <label class="button-heading d-block text-left mb-1">Choose</label>
            <select class="custom-select" @change="setState" v-model="state" :disabled="!countrySelect">
              <option value="" disabled>Select State</option>
              <option v-for="state in getStates" :key="state.id" v-bind:value="{id: state.id, text: state.name}">
                {{ displayStateName(state.name) }}
              </option>
            </select>
          </div>
          <div class="col-12">
            <label class="button-heading d-block text-left mb-1">Match</label>
            <select class="custom-select" @change="setRegion" :disabled="!state" v-model="region">
              <option value="" disabled>Select Region</option>
              <option v-for="region in getRegions" :key="region.id" v-bind:value="{id: region.id, text: region.name}">
                {{ region.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <br class="search-section-spacer">
    <div class="row text-center" id="search-button-black">

      <div class="col-sm-12">
        <a class="button-black" href="javascript:void(0)" @click.prevent="navigateToRoute()">Search</a>
        <br class="search-section-spacer">
      </div>
    </div>
    <br class="search-section-spacer">
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {mapGetters, mapActions} from "vuex";
import { displayStateName } from "@/utils/stateDisplayName";


export default defineComponent({
  name: 'home-search',
  props: {
    name: String,
    countries: Array
  },
  computed: {
    selectableCountries(): any[] {
      return (this.countries || []).filter((country: any) => {
        const countryName = (country?.name || '').trim().toLowerCase();
        return countryName !== 'new zealand' && countryName !== 'nz';
      });
    },
    ...mapGetters({
      getStates: 'states/getStates',
      getRegions: 'regions/getRegions',
    })
  },
  methods: {
    displayStateName,
    ...mapActions({
      fetchStates: 'states/fetchStates',
      fetchRegions: 'regions/fetchRegions',
    }),
    /** Single source of truth for the search URL — avoids duplicated ?state= / ?region= from repeated @change. */
    buildSearchRoute(): string {
      const parts: string[] = [];
      if (this.countrySelect && typeof this.countrySelect === 'object' && this.countrySelect['text']) {
        parts.push(`country=${encodeURIComponent(this.countrySelect['text'])}`);
      }
      if (this.state && typeof this.state === 'object' && this.state['id'] != null && this.state['text']) {
        parts.push(`state=${encodeURIComponent(displayStateName(this.state['text']))}`);
      }
      if (this.region && typeof this.region === 'object' && this.region['id'] != null && this.region['text']) {
        parts.push(`region=${encodeURIComponent(this.region['text'])}`);
      }
      return `/search/smart-cards${parts.length ? `?${parts.join('&')}` : ''}`;
    },
    async setCountry() {
      this.state = '';
      this.region = '';
      this.route = this.buildSearchRoute();
      await this.fetchStates(this.countrySelect['id']);
    },
    async setState() {
      this.region = '';
      this.route = this.buildSearchRoute();
      await this.fetchRegions(this.state['id']);
    },
    async setRegion() {
      this.route = this.buildSearchRoute();
      await this.$router.push(this.route);
    },
    navigateToRoute() {
      this.$router.push(this.buildSearchRoute());
    }
  },
  data() {
    return {
      state: "",
      region: "",
      countrySelect: "",
      route: "/search/smart-cards"
    }
  }
});
</script>

<style scoped>
#search-button-black .button-black,
#search-button-black .button-black:link,
#search-button-black .button-black:visited,
#search-button-black .button-black:hover,
#search-button-black .button-black:focus {
  background-color: #000 !important;
  color: #fff !important;
}

.button-heading {
  text-transform: uppercase;
  font-weight: 900;
}

#tagline p {
  color: #34aade !important;
  font-weight: 700 !important;
}

/* Match label row + select row horizontal inset so columns stay aligned */
.home-select-row {
  padding: 0 clamp(14px, 5vw, 90px) 10px;
}

#search-buttons .button-heading-padding {
  padding-left: clamp(14px, 5vw, 90px) !important;
  padding-right: clamp(14px, 5vw, 90px) !important;
}

/* Full column width + fluid type so long names (e.g. Australian Capital Territory) fit on laptop */
#search-buttons.home-select .home-select-row select.custom-select {
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
  font-size: clamp(0.55rem, 0.35vw + 0.52rem, 0.82rem) !important;
  padding: 0.32rem 1.6rem 0.32rem 0.4rem !important;
  line-height: 1.25;
}

#search-buttons-small.home-select .home-select-row select.custom-select {
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
  font-size: clamp(0.7rem, 1.1vw + 0.55rem, 0.9rem) !important;
}

/* Keep the complete selector and search action visible on short laptop screens. */
@media (min-width: 576px) and (max-height: 700px) {
  #searchbox {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }

  #search-icons-large {
    margin-top: 4px !important;
  }

  #search-icons-large img {
    width: min(52%, 64px) !important;
  }

  #search-icons-large a {
    padding: 2px 0 !important;
  }

  #tagline p {
    margin: 5px 0 !important;
  }

  .search-section-spacer {
    display: none;
  }

  .home-select-row {
    padding-bottom: 5px;
  }

  #search-button-black {
    margin-top: 5px;
    margin-bottom: 8px;
  }
}

@media (max-width: 767.98px) {
  .home-select-row {
    padding: 0 14px 10px;
  }

  #searchbox {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  #search-buttons-small .button-heading {
    font-size: 0.8rem;
    text-align: left;
  }

  #search-buttons-small .mobile-select-stack .col-12 {
    margin-bottom: 10px;
  }
}
</style>
